import type { LocalizedDict } from '../index'

// Extra Personal Drive labels (file-card actions + viewer zoom). Kept apart
// from i18n/shared/drive-personal.ts because that dictionary is also used by
// the admin shell.

export type DrivePersonalExtraStrings = {
  star: string
  trash: string
  zoomOut: string
  zoomIn: string
  fit: string
}

export const drivePersonalExtraI18n: LocalizedDict<DrivePersonalExtraStrings> = {
  en: {
    star: 'Star',
    trash: 'Trash',
    zoomOut: 'Zoom out',
    zoomIn: 'Zoom in',
    fit: 'Fit',
  },
  tr: {
    star: 'Yıldızla',
    trash: 'Çöp kutusuna taşı',
    zoomOut: 'Uzaklaştır',
    zoomIn: 'Yakınlaştır',
    fit: 'Sığdır',
  },
}
